var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLoan(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.70968 13.9367H11.2903C11.4785 13.9367 11.6591 13.8635 11.7921 13.7333C11.9252 13.6031 12 13.4265 12 13.2424V1.09247C12 0.908339 11.9252 0.731746 11.7921 0.601543C11.6591 0.47134 11.4785 0.398193 11.2903 0.398193H1.70968C1.52146 0.398193 1.34095 0.47134 1.20786 0.601543C1.07477 0.731746 1 0.908339 1 1.09247V13.2424C1 13.4265 1.07477 13.6031 1.20786 13.7333C1.34095 13.8635 1.52146 13.9367 1.70968 13.9367Z",
    stroke: "#0C89EF",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.05339 2.46039H8.29638M1.84613 1.24435H11.1538V3.6805H1.84613V1.24435ZM4.08617 4.9636V6.91918H1.8465V4.9636H4.08617ZM4.0858 8.04889V10.0045H1.84613V8.04889H4.0858ZM4.0858 11.1349V13.0905H1.84613V11.1349H4.0858ZM7.62 4.9636V6.91918H5.38033V4.9636H7.62ZM7.61963 8.04889V10.0045H5.37996V8.04889H7.61963ZM7.61963 11.1349V13.0905H5.37996V11.1349H7.61963ZM11.1538 4.9636V6.91918H8.91416V4.9636H11.1538ZM11.1535 8.04889V10.0045H8.91378V8.04889H11.1535ZM11.1535 11.1349V13.0905H8.91378V11.1349H11.1535Z",
    stroke: "black",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.88464 2.09052H10.3077V2.93667",
    stroke: "black",
    strokeWidth: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoan);
export default __webpack_public_path__ + "static/media/loan.bd152b5507a8e3325eb6755087f253aa.svg";
export { ForwardRef as ReactComponent };